import { BaseBloc } from '@core/utils/bloc';
import { tap, map } from 'rxjs/operators';
import { GCNotification } from '@business/entities/notifications';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { NotificationAPI } from '@business/api/notifications';

export class NotificationBloc extends BaseBloc {
  unreadCount$ = new BehaviorSubject<number>(0);
  notifications$ = new BehaviorSubject<GCNotification[]>([]);
  newNotification$ = new BehaviorSubject<GCNotification | null>(null);

  reload() {
    return forkJoin(
      NotificationAPI.getNotificationCount().pipe(tap(data => this.unreadCount$.next(data.count))),
      NotificationAPI.getNotiifcations().pipe(tap(data => this.notifications$.next(data))),
    );
  }

  notifications(after?: number) {
    return NotificationAPI.getNotiifcations(after);
  }

  onReset() {}

  onInit() {}

  addNotification(notification: GCNotification) {
    this.notifications$.next([notification, ...this.notifications$.value]);
    this.unreadCount$.next(this.unreadCount$.value + 1);
    this.newNotification$.next(notification);
  }
}
